import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import HeadingBanner from "../../components/common/HeadingBanner";
import EmailBanner from "../../components/home/EmailBanner";

const Partner = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_lw92dka",
        "template_d23bf2h",
        form.current,
        "Ic_RaxZmAKBkf8h5i",
      )
      .then(() => {
        alert("Message sent successfully");
        form.current.reset();
      })
      .catch((error) => {
        console.log(error);
        alert("Something went wrong");
      });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
          <div>
            <HeadingBanner  title="Partner" />
        </div>

      {/* Form section */}

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left */}

            <div>
              <h2 className="text-4xl font-bold mb-6">Let's Work Together</h2>

              <p className="text-gray-600 leading-8 mb-6">Are you interested in integrating sustainable actions at the core
              of your business? It can be anything starting from training to
              software development. You can be a part of us to make it bigger.
              We assure you that the benefits are many and we will be more than
              happy to guide you through.</p>

              <p className="text-gray-600 leading-8 mb-6">
                Please fill the information below and we will get in touch with
                you.
              </p>

              <div className="bg-blue-50 border-l-4 border-[#7B96BD] p-5 rounded">
                <p className="text-gray-700">
                  Direct Email:
                  <span className="font-semibold ml-2">
                    info@techmentee.com
                  </span>
                </p>
              </div>
            </div>

            {/* Form */}

            <div className="bg-white p-8 rounded-3xl shadow-xl">
              <form ref={form} onSubmit={sendEmail} className="space-y-5">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  required
                  className="w-full p-4 rounded-xl border outline-none focus:border-[#7B96BD]"
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                  className="w-full p-4 rounded-xl border outline-none focus:border-[#7B96BD]"
                />

                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  className="w-full p-4 rounded-xl border outline-none focus:border-[#7B96BD]"
                />

                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  className="w-full p-4 rounded-xl border outline-none focus:border-[#7B96BD]"
                />

                <textarea
                  rows="5"
                  name="message"
                  placeholder="Tell us about your partnership idea..."
                  className="w-full p-4 rounded-xl border outline-none focus:border-[#7B96BD]"
                />

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#7B96BD] to-[#6988b3] py-4 rounded-xl text-white font-semibold hover:scale-[1.02] transition"
                >
                  Submit Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div>
         <EmailBanner />
      </div>
    </div>
  );
};

export default Partner;
